import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { dotmapsBlue } from '@constants/colors';

import { Progress } from '@mui';

import styles from './dotmaps-loader.scss';

const DotmapsLoader = ({ display, color, small }) => {
  if (!display) {
    return null;
  }

  const size = small ? 30 : 70;

  return (
    <div
      className={classNames(styles.dotmapsLoaderContainer, {
        [styles.small]: small
      })}
    >
      <Progress
        size={size}
        thickness={3}
        progressColor={color}
      />
    </div>
  );
};

DotmapsLoader.propTypes = {
  color: PropTypes.string,
  display: PropTypes.bool,
  small: PropTypes.bool
};

DotmapsLoader.defaultProps = {
  color: dotmapsBlue,
  display: true
};

export default DotmapsLoader;
